export default {
  TITLE: '亚马逊海外购使用条件',
  CONTENT: `
    <h3>亚马逊海外购使用条件</h3>
    <p>
      欢迎访问亚马逊海外购。亚马逊海外购的每件商品（“海外购商品”）均由以下表格中所列亚马逊海外实体（“亚马逊海外实体”）之一销售及发货。您一旦下单购买任何海外购商品，即表示您同意本亚马逊海外购使用条件（本“使用条件”）。
    </p>
    <h3>适用法律、争议解决及适用的使用条件</h3>
    <p>
      在购买海外购商品时，您承认（1）您是从相关的亚马逊海外实体（如下表所列）订购商品，等同于从相关的亚马逊海外网站（如下表所列）购买商品；（2）在购买之时该等商品尚未进口到中国内地（即，香港特别行政区、澳门特别行政区及台湾除外）
      （为本文件之目的，下文提及的“中国”具有与上文规定相同的含义）；及（3）且该销售发生在原商品销售国，并受如下所列、适用的亚马逊海外网站的使用条件（“适用的使用条件”）的约束。特别地，您同意，下表中所列适用法律和争议解决（其详细规定见适用的使用条件）将适用，并放弃因任何原因可能适用的任何其他司法管辖权。
    </p>
    <table cellspacing="0" cellpadding="0">
      <tr>
        <td>亚马逊海外网站</td>
        <td>Amazon.com</td>
        <td>Amazon.co.uk</td>
        <td>Amazon.co.jp</td>
        <td>Amazon.de</td>
      </tr>
      <tr>
        <td>亚马逊海外实体</td>
        <td>Amazon Export Sales LLC</td>
        <td>Amazon EU SARL</td>
        <td>Amazon Japan Godo Kaisha</td>
        <td>Amazon EU SARL</td>
      </tr>
      <tr>
        <td>适用法律</td>
        <td>美国法律</td>
        <td>卢森堡大公国法律</td>
        <td>日本法律</td>
        <td>卢森堡大公国法律</td>
      </tr>
      <tr>
        <td>争议解决</td>
        <td>由美国仲裁协会仲裁</td>
        <td>卢森堡市区法院</td>
        <td>东京地方法院</td>
        <td>卢森堡市区法院</td>
      </tr>
      <tr>
        <td rowspan="2">适用的使用条件</td>
        <td>
          <p>
            <a data-path="https://www.amazon.com/gp/help/customer/display.html/ref=footer_cou?ie=UTF8&nodeId=508088">亚马逊美国的使用条件</a>（英文原文）
          </p>
          <p>
            <a data-path="https://www.amazon.com/gp/help/customer/display.html?nodeId=14309551">国际配送条款和条件</a>（英文原文）
          </p>
        </td>
        <td>
          <a data-path="https://www.amazon.co.uk/gp/help/customer/display.html/ref=footer_cou?ie=UTF8&nodeId=1040616">英国亚马逊的使用及销售条件</a>（英文原文）
        </td>
        <td>
          <a data-path="https://www.amazon.co.jp/gp/help/customer/display.html?nodeId=201909000">亚马逊日本的使用条件</a>（日文原文）
        </td>
        <td>
          <a data-path="https://www.amazon.de/gp/help/customer/display?nodeId=505048">德国亚马逊的使用及销售条件</a>（英文原文）
        </td>
      </tr>
      <tr>
        <td>
          <p>
            <a data-path="termStatement" data-title="USE_CONDITION">亚马逊美国的使用条件</a>（中文翻译，仅供参考）
          </p>
          <p>
            <a data-path="protocol" data-title="INTERNATIONAL_DELIVERY">国际配送条款和条件</a>（中文翻译，仅供参考）
          </p>
        </td>
        <td>英国亚马逊的使用及销售条件（中文翻译，仅供参考）</td>
        <td>
          <a data-path="https://www.amazon.co.jp/gp/help/customer/display.html?nodeId=201909000">亚马逊日本的使用条件</a>（中文翻译，仅供参考）
        </td>
        <td>德国亚马逊的使用及销售条件（中文翻译，仅供参考）</td>
      </tr>
    </table>
    <p>
      如果本使用条件的任何条款与适用的使用条件（如上表所列）或amazon.cn使用条件有冲突，该冲突应根据以下排序来解决：（1）本使用条件；（2）适用的使用条件；及（3）amazon.cn使用条件。
    </p>
    <h3>进口责任</h3>
    <p>
      购买海外购商品时，您对合法进口商品到中国负全责，且为中国海关清关的进口方。商品的灭失风险及所有权自我们将其交付给承运人时即转移给您。您可能需缴纳中国海关及税务部门征收的税费（“进口税费”），
      这些税费会在货物进口到中国时产生。关于进口税费的更多详细信息请参见下文。您同意，您将是商品的最终消费者或您将把商品作为礼物送给其他个人，且在任何情况下均仅为个人用途、非为转售而购买商品。
    </p>
    <h3>对进口商品的特别说明</h3>
    <p>
      海外购商品是从其它原商品销售地运至中国的进口商品，生产商提供的质保和其他售后服务可能不包括中国；商品标签和包装、手册、说明书及安全警示可能没有中文版本；
      且商品可能不是按照中国的标准与使用习惯设计的。您有责任正确使用商品，且完全理解所有相关说明与警示。
    </p>
    <h3>进口税费</h3>
    <p>
      作为进口商品，海外购商品可能需缴纳进口税费。作为进口方，您有义务支付该等进口税费。我们会预估海外购商品的进口税费（“预估进口税费”），并在您下单时向您收取预估进口税费。
      对于被收取预估进口税费的每件海外购商品，您均授权亚马逊海外实体指派承运人（“指定承运人”）作为您在中国相关海关与税务部门的代理，为货物进行清关、并处理并支付实际进口税费。
    </p>
    <p>
      预估进口税费不是向中国政府部门支付的实际金额（“实际进口税费”）。从对进口税费的估算之日到实际进入中国缴纳这些税费之日，适用于特定商品的海关条例和税率可能会在此期间有所变化。
      进口税费的税率通常是由商品的类别决定的。您下订单即表示您同意允许亚马逊海外实体收取您订单中相关商品的预估进口税费。预估进口税费将以您的名义使用，以偿付指定承运人代表您向有关中国政府部门支付的实际进口税费。
      您也同意承运人或其他代理可向亚马逊海外实体披露实际进口税费。如果实际进口税费少于预估进口税费，您会收到差额部分的自动退款。您将收到确认退款金额的通知邮件。自完成清关之日后大约180日内您将收到退还款项。
      如果实际进口税费多于预估进口税费，您无需额外付款。如您欲获取实际进口税费的详情，或清关的文件或收据，请联系您收到的发货确认邮件中的指定承运人。
    </p>
    <h3>退货、退款及所有权</h3>
    <p>
      亚马逊海外实体在货物抵达其库房前对退回的货物不享有所有权。亚马逊海外实体可自主选择在不要求退货或享有退回商品的所有权的前提下进行退款。
    </p>
    <h3>商品信息和价格</h3>
    <p>
      亚马逊努力使亚马逊海外购商品信息尽可能准确。但是，亚马逊海外实体并不保证亚马逊海外购商品描述是准确的、完整的、可靠的、最新的或无误的。为客户的便利，
      我们有时会提供外国语言的机器翻译，仅供您参考。如果亚马逊海外实体提供的商品与网站描述的不一致，您唯一的救济是退货退款。
    </p>
    <p>
      对于亚马逊海外实体销售的商品，只有您提交了订单后方能确认商品的价格。尽管我们尽最大的努力，亚马逊海外购商店的一小部分商品可能偶尔会出现错价。如果亚马逊海外实体销售商品的正确价格高于网站显示的价格，
      亚马逊海外实体有权根据情况决定，在发货前联系您咨询您的意见，或取消您的订单并通知您。
    </p>
    <h3>责任</h3>
    <p>
      在适用法律所允许的最大限度内，亚马逊海外实体不承诺所有明示或默示的担保，包括但不限于对适销性和满足特定目的的默示担保。除非另有明确的书面说明，亚马逊海外实体不对任何直接、
      间接或附带的惩罚性和结果性的损害赔偿承担责任；且在任何情况下，亚马逊海外实体承担的最大责任均不应超过就相关商品您支付的成本。
    </p>
    <h3>隐私</h3>
    <p>
      为购买亚马逊海外购商品，您同意每个亚马逊海外网站收集或获取您的amazon.cn账户的相关信息。每个亚马逊海外网站将根据它们各自的隐私声明保存和使用该等信息。亚马逊海外网站的隐私声明见下表：
    </p>
    <table cellspacing="0" cellpadding="0">
      <tr>
        <td>亚马逊海外网站</td>
        <td>Amazon.com</td>
        <td>Amazon.co.uk</td>
        <td>Amazon.co.jp</td>
        <td>Amazon.de</td>
      </tr>
      <tr>
        <td rowspan="2">隐私声明</td>
        <td>
          <a data-path="https://www.amazon.com/gp/help/customer/display.html/ref=footer_privacy?ie=UTF8&nodeId=468496">亚马逊美国的隐私声明</a>（英文原文）
        </td>
        <td>
          <a data-path="https://www.amazon.co.uk/gp/help/customer/display.html/ref=footer_privacy?ie=UTF8&nodeId=502584">亚马逊英国的隐私声明</a>（英文原文）
        </td>
        <td>
          <a data-path="https://www.amazon.co.jp/gp/help/customer/display.html?nodeId=201909010">亚马逊日本的隐私声明</a>
        </td>
        <td>
          <a data-path="https://www.amazon.de/gp/help/customer/display?nodeId=3312401">亚马逊德国的隐私声明</a>（英文原文）
        </td>
      </tr>
      <tr>
        <td>
          <a data-path="termStatement" data-title="PRIVACY_STATEMENT">亚马逊美国的隐私声明</a>（中文翻译，仅供参考）
        </td>
        <td>
          <a data-path="termStatement" data-title="PRIVACY_STATEMENT">亚马逊英国的隐私声明</a>（中文翻译，仅供参考）
        </td>
        <td>
          <a data-path="https://www.amazon.co.jp/gp/help/customer/display.html?nodeId=201909010">亚马逊日本的隐私声明</a>（中文翻译，仅供参考）
        </td>
        <td>
          <a data-path="termStatement" data-title="PRIVACY_STATEMENT">亚马逊德国的隐私声明</a>（中文翻译，仅供参考）
        </td>
      </tr>
    </table>
    <p>
      您的隐私对我们非常重要，且我们知道您关心您的订单信息是如何被使用和分享的。我们希望我们的客户知悉，跨境运输需接受海关及/或邮政部门的开箱检查。
    </p>
    <p>
      我们也可能将某些订单、运送及商品信息（如商品名称或标题），提供给我们的国际承运人或代理，且该等信息可能因清关及为符合法律的规定而经由承运人或代理提供给海关及/或邮政部门。
    </p>
  `
};
